// Lucide icon: settings (https://lucide.dev/icons/settings)
import { Settings } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconSettings = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Settings />
    </IconComponentStyled>
  )
}
